import {AppRoutes} from '@/shared/types/routes';

import {CookiePreferences} from './types';

export const OPEN_COOKIE_PREFERENCES_EVENT = 'open-cookie-preferences';
export const AGREE_COOKIE_PREFERENCES_EVENT = 'agree-cookie-preferences';

export const MODAL_STATE = {
  initial: 'initial',
  preference: 'preference',
} as const;

export const INITIAL_MODAL_PREFERENCES: CookiePreferences = {
  statistics: false,
  marketing: false,
};

export const COOKIE_SECTIONS = [
  {
    key: 'essential',
    titleKey: 'cookie_consent_essential_title',
    descriptionKey: 'cookie_consent_tools_necessary_description',
    required: true,
  },
  {
    key: 'statistics',
    titleKey: 'cookie_consent_statistics_title',
    descriptionKey: 'cookie_consent_understand_description',
    required: false,
  },
  {
    key: 'marketing',
    titleKey: 'cookie_consent_marketing_title',
    descriptionKey: 'cookie_consent_relevant_description',
    required: false,
  },
] as const;

export const SUPPRESSED_COOKIE_BANNER_PATTERNS: readonly AppRoutes[] = [
  '/:lang?/privacy',
  '/:lang?/privacy-policy',
  '/:lang?/under-maintenance',
  '/build-info',
  '/:lang?/error-banned',
  '/:lang?/error-vpn',
  '/:lang?/ambassador-public-agreement',
  '/:lang?/cookie-policy',
  '/:lang?/terms',
  '/:lang?/terms-of-service',
  '/:lang?/community-guidelines',
  '/:lang?/contacts',
  '/:lang?/contact-us',
  '/push',
  '/pay-wall-standalone',
  '/resume-signup',
  '/shared-link/:sharedToken',
  '/email-confirmation',
  '/sign-in-continue',
  '/checkout',
  '/checkout/success',
  '/checkout/error',
  '/confirm-signup/:token',
  '/payment-result/error/:paymentId',
  '/payment-result/success/:paymentId',
  '/__hidden_callback__',
  '/app/photo-issues/:issue?',
  '/app/verification',
  '/:lang?/onboarding-email',
  '/:lang?/onboarding-social',
  '/:lang?/onboarding-real-couples',
  '/land/asian',
  '/land/latin',
  '/land/friends-v1',
  '/land/friends-v2',
  '/:lang?/land-lite',
  '/land/ph-en-real-couples',
  '/land/ph-en',
  '/land/e2',
];
